import classnames from 'classnames';
import React from 'react';

import { css } from 'config/emotionCss';

import {
  ROLES,
  STATUS,
  AUDIT_STATUS,
  EMAIL_STATUS,
  FOLLOW_UP_STATUS,
  CAMPAIGNS_STATUS,
  APPOINTMENT_STATUS,
  INTERVENTION_STATUS,
  CAMPAIGN_FILES_STATUS,
  INTERVENTION_PAYMENT_STATUS,
  APPOINTMENT_TYPE,
} from 'constants/FilterConstants';
import { Tag } from 'ui/base';
import { createDictionary } from 'utils/ObjectUtils';

import { CAMPAIGN_FILE_STATUS as CAMPAIGN_FILE_STATUS_ENUM } from '../../../campaigns/Details/constants';

export const CLASS_NAME_BY_TYPE = createDictionary(
  {
    [ROLES]: role => role?.toLowerCase(),
    [STATUS]: status => status?.toLowerCase(),
    [APPOINTMENT_TYPE]: type => type?.toLowerCase(),
    [EMAIL_STATUS]: status => status?.toLowerCase(),
    [AUDIT_STATUS]: status => status?.toLowerCase(),
    [FOLLOW_UP_STATUS]: status => status?.toLowerCase(),
    [INTERVENTION_STATUS]: status => status?.toLowerCase(),
    [CAMPAIGNS_STATUS]: status => [status?.toLowerCase() ?? 'default'],
    [APPOINTMENT_STATUS]: status => `appointment-${status?.toLowerCase()}`,
    [CAMPAIGN_FILES_STATUS]: status =>
      (status === CAMPAIGN_FILE_STATUS_ENUM.PENDING ? `campaignFile-${status?.toLowerCase()}` : status?.toLowerCase()),
    [INTERVENTION_PAYMENT_STATUS]: status => `payment-${status.toLowerCase()}`,
  },
  () => 'default'
);

const tagStyle = css`
  &.ant-tag {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & + .ant-tag {
      margin-left: 0px !important;
    }
  }
`;

/**
 * @typedef {{
 *  filterId: string;
 *  onDelete : (filterId: string, value: any) => void;
 *  className ?: Array<string>;
 * } & import('../types').FilterValue } Props
 *
 * @returns {React.FC<Props>}
 */
const FilterTag = ({ value, name, filterId, onDelete, className }) => {
  const handleRemoveFilter = () => onDelete(filterId, value);

  return (
    <Tag
      closable
      data-cy={`filter-tag-${filterId}`}
      onClose={handleRemoveFilter}
      className={classnames(CLASS_NAME_BY_TYPE[filterId](value), tagStyle, className)}
    >
      {name}
    </Tag>
  );
};

export default FilterTag;
